import React from 'react'
import Spinner from 'common/components/Spinner'
import { Job, JobWizard, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

const LandingPageQuotesButton = React.createClass({
  getInitialState: function () {
      return { loading: false }
  },

  componentDidMount() {
    this.insertStepsForThisCategory()
  },

  insertStepsForThisCategory() {
    let selectedCategoryDetails = () => {
      return { item: { id: this.props.subcategoryId, value: this.props.subcategoryName } }
    }

    function noCategoriesSelected() {
      return Job.Data.categories.length === 0
    }

    if(noCategoriesSelected()) {
      JobWizard.Emitter.emit('job:wizard:categorySelected', null, selectedCategoryDetails())
      Job.Actions.updateCategory(selectedCategoryDetails().item)
      Job.Actions.updateSubCategory(selectedCategoryDetails().item, 'add')
    }
  },

  showJobWizardModal() {
    if (window.mobilecheck() === true) {
      JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.SelectLocation);
    }
    else {
      JobWizard.Emitter.emit('job:wizard:hideCategoryInput', {showCategoryInput: false})
    }

    $('#job-modal').modal({keyboard: false, backdrop: 'static'}, { cta: this.props.cta })
    this.setState({loading: false })
  },

  setSuburbInfo() {
    let suburb = $('#job_suburb.suburb-typeahead').val() || "" // suburb's value must not be `undefined`, because when redirected to old landing page it will rendered the word `undefined`
    let suburbIdFieldVal = $('#job_suburb_id').val()

    let suburbId = suburbIdFieldVal ? Number(suburbIdFieldVal) : 0

    Job.Actions.updateLocation({ id: suburbId, value: suburb })
    JobWizard.Emitter.emit('change')
  },

  handleOnClick(event) {
    event.preventDefault()
    this.setState({loading: true })
    this.insertStepsForThisCategory()
    this.setSuburbInfo()
    this.showJobWizardModal()
  },

  render() {
    return(
      <a className={this.props.buttonClass} href="#" onClick={this.handleOnClick}>
        {
          this.state.loading ?
            <Spinner spinnerColour='white-spinner' />
          :
          <span>
            {this.props.buttonText}
            {this.props.withArrow && <i className="ficon-arrow-right-shaft pl10" />}
          </span>
        }
      </a>
    )
  }
})

export default LandingPageQuotesButton
